export const SLOT_TYPE = {
  TOP: 'TOP',
  MIJN: 'MIJN'
}

export const ACTIVE_TYPE = {
  ALL: 'ALL',
  TOP: 'TOP',
  MIJN: 'MIJN'
}